import { useContext } from 'react';
import OptionsContext from './OptionsContext';

const useOptions = () => useContext(OptionsContext);

export default useOptions;
